// extracted by mini-css-extract-plugin
export default {"tr":"DesignSoilParameters_tr__AZAAm","tdLeft":"DesignSoilParameters_tdLeft__-vKnP"};